module.exports = __webpack_public_path__ + "img/ctrl-rz-stub-mid-+.9296a3d3.svg";